import React, { useEffect } from 'react';
import { useRedux } from 'use-redux';
import { formatDate } from '@utils/date';
import { Translate, I18n } from 'react-redux-i18n';

import ReactTable from 'react-table';
import 'react-table/react-table.css';

import Row from 'react-bootstrap/lib/Row';
import { getPayments as actionGetPayments } from '../../actions/user';

import { STATUSES } from '../gui/admin/stats/PaymentStats';

const LessonsHistory = () => {
  const [{ auth }, dispatch] = useRedux();
  const { lessons = [] } = auth;

  const data = lessons.map(l => ({
    date: l.start,
    comment: l.comment,
    status: l.status,
    action: I18n.t('userSubscribition.lessonsHistory.lesson'),
  }));

  useEffect(() => {
    dispatch(actionGetPayments());
  }, [dispatch]);

  const columns = [
    {
      Header: I18n.t('userSubscribition.lessonsHistory.action'),
      accessor: 'action',
      width: 150,
    },
    {
      Header: I18n.t('userSubscribition.lessonsHistory.date'),
      accessor: 'date',
      Cell: props => formatDate(props.value, 'lll'),
      width: 250,
    },
    {
      Header: I18n.t('userSubscribition.lessonsHistory.comment'),
      accessor: 'comment',
      style: { whiteSpace: 'normal' },
    },
    {
      Header: I18n.t('userSubscribition.lessonsHistory.status'),
      accessor: 'status',
      show: false,
    },
  ];

  return (
    <div className="container-fluid new-style code-gray-bg">
      <Row className="md-container">
        <h2 className="title">
          <div className="quote" />
          {<Translate value="userSubscribition.lessonsHistory.title" />}
        </h2>

        <ReactTable
          data={data}
          columns={columns}
          className="bg-white"
          defaultPageSize={10}
          showPageSizeOptions={false}
          sortable={false}
          defaultSorted={[
            {
              id: 'date',
              desc: true,
            },
          ]}
          getTrProps={(state, rowInfo, column) => {
            const status = rowInfo && rowInfo.row.status;
            const current = STATUSES.find(s => s.elements.includes(status));

            return {
              className: current ? current.className : '',
            };
          }}
        />
      </Row>
    </div>
  );
};

export default LessonsHistory;
